import { string2money } from 'common/utils/string';
import Stack from 'components/commons/stack';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { HeaderText, ItemCard, SmallLabel, styles, ValueText } from './style';
import { AbsolutePosition, TabItemContainer } from '../style';

interface Props {
  data: {
    passengerName: string;
    number: string;
    totalPrice: string;
    headerText: string;
  }[];
}

export default function FacilityDetail(props: Props) {
  const { t } = useTranslation();

  return (
    <TabItemContainer>
      <AbsolutePosition>
        {props.data.map((item, idx) => (
          <ItemCard key={`facility-${idx}`}>
            <Stack
              direction="horizontal"
              justify="between"
              rootCss={{ borderBottom: '1px solid $dbGray1', mb: 12, pb: 12 }}
            >
              <HeaderText>{item.headerText}</HeaderText>
              <HeaderText>Rp {string2money(item.totalPrice)}</HeaderText>
            </Stack>
            <Stack direction="horizontal" gap="md" wrap justify="between">
              <Stack.Item css={styles.content}>
                <Stack.Item css={{ flex: 1 }}>
                  <SmallLabel>{t('common:passenger_name')}</SmallLabel>
                  <ValueText>{item.passengerName}</ValueText>
                </Stack.Item>
                <Stack.Item css={{ flex: 1 }}>
                  <SmallLabel>{t('booking:facility_number')}</SmallLabel>
                  <ValueText>{item.number}</ValueText>
                </Stack.Item>
              </Stack.Item>
            </Stack>
          </ItemCard>
        ))}
      </AbsolutePosition>
    </TabItemContainer>
  );
}
